import React from "react";
import ReactHtmlParser from "html-react-parser";
import icons from "../icons/timeline";

const singlePrizeData = {
  stepper: {
    vertical: {
      title: "Draw dates",
      subtitle:
        "Two Dream Homes for the price of one with every ticket bought before August 31. Claim your chance to win now.",
      steps: [
        {
          isActive: true,
          leftText: ReactHtmlParser("£2.5m Wiltshire Dream Home"),
          rightText: ReactHtmlParser(
            "Closed February 28.<br/>Winner announced!"
          ),
          icon: icons.checked,
          badgeImage: "hour-glass",
        },
        {
          isActive: false,
          leftText: ReactHtmlParser("£2.8m Warwickshire Dream Home launched"),
          rightText: ReactHtmlParser("Closes April 30.<br/>Drawn May 8."),
          icon: icons.home,
          badgeImage: "hour-glass",
        },
        {
          isActive: false,
          leftText: ReactHtmlParser("Maserati Bonus Draw"),
          rightText: ReactHtmlParser("Closed March 31.<br/>Drawn April 7."),
          icon: icons.car,
          badgeImage: "hour-glass",
        },
      ],
    },
    horizontal: {
      title: "Draw dates",
      subtitle: ReactHtmlParser(
        "Two Dream Homes for the price of one with every ticket bought before August 31. Claim your chance to win now."
      ),
      steps: [
        {
          leftText: ReactHtmlParser("£3m West Sussex Dream Home launched"),
          rightText: ReactHtmlParser(
            "Launched Jul 1.<br/>Closes Aug 31.<br/>Drawn Sep 5."
          ),
          icon: icons.home,
        },
        {
          leftText: ReactHtmlParser("Porsche Early Bird launched"),
          rightText: ReactHtmlParser(
            "Closed July 31.<br/>Winner announced August&nbsp;10."
          ),
          icon: icons.car,
        },
        {
          leftText: ReactHtmlParser("£2.5m Historic Dream Home launched"),
          rightText: ReactHtmlParser(
            "2-4-1 offer live on all tickets<br/>until August&nbsp;31."
          ),
          icon: icons.home,
        },
      ],
    },
  },
  ticketSelector: {
    title: "",
    subtitle:
      "Two Dream Homes for the price of one with every ticket bought before August 31. Claim your chance to win now.",
  },
};

const doublePrizeData = {
  stepper: {
    vertical: {
      title: "Draw dates",
      subtitle:
        "Two Dream Homes for the price of one with every ticket bought before August 31. Claim your chance to win now.",
      steps: [
        {
          isActive: true,
          leftText: ReactHtmlParser("£2.5m Wiltshire Dream Home"),
          rightText: ReactHtmlParser(
            "Closed February 28.<br/>Winner announced!"
          ),
          icon: icons.checked,
          badgeImage: "hour-glass",
        },
        {
          isActive: false,
          leftText: ReactHtmlParser("£2.8m Warwickshire Dream Home launched"),
          rightText: ReactHtmlParser("Closes April 30.<br/>Drawn May 8."),
          icon: icons.home,
          badgeImage: "hour-glass",
        },
        {
          isActive: false,
          leftText: ReactHtmlParser("Maserati Bonus Draw"),
          rightText: ReactHtmlParser("Closed March 31.<br/>Drawn April 7."),
          icon: icons.car,
          badgeImage: "hour-glass",
        },
      ],
    },
    horizontal: {
      title: "Draw dates",
      subtitle: ReactHtmlParser(
        "Two Dream Homes for the price of one with every ticket bought before August 31. Claim your chance to win now."
      ),
      steps: [
        {
          leftText: ReactHtmlParser("£3m West Sussex Dream Home launched"),
          rightText: ReactHtmlParser(
            "Launched Jul 1.<br/>Closes Aug 31.<br/>Drawn Sep 5."
          ),
          icon: icons.home,
        },
        {
          leftText: ReactHtmlParser("Porsche Early Bird launched"),
          rightText: ReactHtmlParser(
            "Closed July 31.<br/>Winner announced August&nbsp;10."
          ),
          icon: icons.car,
        },
        {
          leftText: ReactHtmlParser("£2.5m Historic Dream Home launched"),
          rightText: ReactHtmlParser(
            "2-4-1 offer live on all tickets<br/>until August&nbsp;31."
          ),
          icon: icons.home,
        },
      ],
    },
  },
  ticketSelector: {
    title: "",
    subtitle:
      "Two Dream Homes for the price of one with every ticket bought before August 31. Claim your chance to win now.",
  },
};

const dreamDrawAccordion = [
  {
    title: "Value",
    answer: (
      <React.Fragment>
        <ul className="faq-list dark">
          <li>
            £4 million with not a penny of Stamp Duty to pay. Or, if you’d
            rather be an overnight millionaire, take the cash, tax-free.
          </li>
        </ul>
      </React.Fragment>
    ),
    icon: (
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.9974 1.1665C3.94745 1.1665 0.664062 4.4496 0.664062 8.49984C0.664062 12.5501 3.94745 15.8332 7.9974 15.8332C12.0473 15.8332 15.3307 12.5498 15.3307 8.49984C15.3307 4.44989 12.0473 1.1665 7.9974 1.1665ZM7.74818 7.88911H9.63193V9.4844H7.81578L7.84643 10.1739C7.84643 10.6417 7.72583 11.0092 7.48435 11.2759H11.2149V12.9325H4.65557V11.2759H5.2875C5.52068 11.2143 5.64328 11.0029 5.6556 10.6417L5.66161 10.3154L5.63096 9.48411H4.63695V7.88882H5.58198L5.54503 6.55736C5.54503 5.7189 5.79539 5.0632 6.29669 4.59083C6.79771 4.11846 7.47576 3.88213 8.33083 3.88213C9.24721 3.88213 9.96193 4.11731 10.4753 4.58768C10.9886 5.05804 11.2453 5.69627 11.2453 6.50208H9.22029C9.22029 5.85984 8.94214 5.53872 8.38583 5.53872C8.17729 5.53872 8.00943 5.6215 7.88281 5.78736C7.75591 5.95294 7.6926 6.20989 7.6926 6.55736L7.74789 7.88882L7.74818 7.88911Z"
          fill="white"
        />
      </svg>
    ),
  },
  {
    title: "Location",
    answer: (
      <React.Fragment>
        <ul className="faq-list dark">
          <li>
            One of the most prestigious counties in the U.K.; Surrey is on
            London's doorstep though surrounded by picturesque British
            countryside.
          </li>
        </ul>
      </React.Fragment>
    ),
    icon: (
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        tabindex="-1"
        title="Location"
      >
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5"></path>
      </svg>
    ),
  },
  {
    title: "Furnishings",
    answer: (
      <React.Fragment>
        <ul className="faq-list dark">
          <li>
            The property is yours fully furnished, complete with more than
            £200,000 of opulent and perfectly styled décor.
          </li>
        </ul>
      </React.Fragment>
    ),
    icon: (
      <svg
        width="224"
        height="240"
        viewBox="0 0 224 240"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M90.2187 20.583H19.5934V68.4722H90.2187V20.583ZM16.3121 89.0555H82.0867C82.852 86.5498 84.34 84.3661 86.3383 82.8162C88.3365 81.2661 90.7428 80.4293 93.2134 80.4251H109.516V3.5001C109.514 2.57237 109.168 1.68312 108.553 1.02712C107.938 0.37111 107.104 0.00180882 106.234 9.06699e-05H3.5782C2.70835 0.00180882 1.87465 0.37111 1.25965 1.02712C0.64471 1.68312 0.29848 2.57237 0.296875 3.5001V236.501C0.29848 237.427 0.64471 238.317 1.25965 238.973C1.87465 239.629 2.70835 239.998 3.5782 240H106.234C107.104 239.998 107.938 239.629 108.553 238.973C109.168 238.317 109.514 237.427 109.516 236.501V194.712H102.932V204.178C102.932 205.106 102.586 205.995 101.971 206.651C101.355 207.309 100.521 207.677 99.6504 207.677H96.7807V222.917C96.7807 223.845 96.435 224.734 95.8195 225.392C95.2042 226.048 94.3696 226.416 93.4995 226.416H16.3121C15.442 226.416 14.6074 226.048 13.992 225.392C13.3767 224.734 13.0309 223.845 13.0309 222.917V168.027C13.0309 167.099 13.3767 166.21 13.992 165.552C14.6074 164.896 15.442 164.528 16.3121 164.528H72.5871V160.504C68.445 158.606 65.0542 155.224 62.9997 150.944H16.3121C15.442 150.944 14.6074 150.575 13.992 149.919C13.3767 149.263 13.0309 148.372 13.0309 147.444V92.555C13.0311 91.6269 13.3768 90.7368 13.9921 90.0805C14.6076 89.4243 15.442 89.0555 16.3121 89.0555ZM13.0309 17.083C13.0309 16.1549 13.3767 15.2646 13.992 14.6082C14.6074 13.9518 15.442 13.5831 16.3121 13.5831H93.4999C94.3701 13.5831 95.2047 13.9518 95.8201 14.6082C96.4354 15.2646 96.7812 16.1549 96.7812 17.083V71.9722C96.7812 72.9003 96.4354 73.7906 95.8201 74.447C95.2047 75.1034 94.3701 75.4722 93.4999 75.4722H16.3121C15.442 75.4722 14.6074 75.1034 13.992 74.447C13.3767 73.7906 13.0309 72.9003 13.0309 71.9722V17.083ZM212.311 9.06699e-05H178.806C177.942 -0.00614301 177.102 0.309229 176.431 0.89197C175.761 1.47471 175.302 2.2884 175.132 3.19309L167.481 42.8226C167.367 43.4045 167.376 44.0062 167.506 44.5838C167.638 45.1616 167.89 45.7005 168.241 46.1614C168.594 46.6222 169.038 46.9933 169.542 47.2472C170.046 47.5013 170.596 47.632 171.154 47.6296H219.963C220.519 47.632 221.07 47.5013 221.574 47.2472C222.078 46.9933 222.522 46.6222 222.874 46.1614C223.227 45.7005 223.477 45.1616 223.609 44.5838C223.741 44.0062 223.75 43.4045 223.635 42.8226L215.985 3.19309C215.815 2.2884 215.356 1.47471 214.686 0.89197C214.015 0.309229 213.175 -0.00614301 212.311 9.06699e-05ZM202.027 139.95C202.188 141.977 202.065 144.019 201.66 146.007H220.185C220.35 146.007 220.512 145.961 220.654 145.873C220.797 145.785 220.915 145.659 220.998 145.507C221.08 145.355 221.124 145.182 221.124 145.007C221.124 144.831 221.08 144.659 220.998 144.507L218.812 140.45C218.733 140.296 218.614 140.168 218.472 140.08C218.328 139.992 218.166 139.947 218.001 139.95L202.027 139.95ZM193.099 124.355C194.982 125.622 196.644 127.226 198.016 129.095V54.6291H193.099V124.355ZM81.5182 121.262V96.055H19.5934V143.945H61.0234C60.7315 141.084 61.0071 138.189 61.8322 135.449C62.6572 132.71 64.0135 130.185 65.8126 128.041C67.6119 125.897 69.8139 124.18 72.2755 123.002C74.7373 121.825 77.4037 121.213 80.1016 121.206C80.5773 121.206 81.0504 121.225 81.5182 121.262ZM174.921 123.067V92.9002C174.916 91.4494 174.375 90.0594 173.413 89.0334C172.45 88.0077 171.148 87.4294 169.788 87.4251H93.2134C91.8532 87.4291 90.5499 88.0074 89.5881 89.0331C88.6263 90.059 88.0842 91.4493 88.0801 92.9002V123.067C91.4193 124.707 94.2493 127.33 96.2371 130.628C98.2249 133.926 99.2875 137.762 99.2997 141.683V159.062C99.3022 159.72 99.5484 160.35 99.9846 160.814C100.421 161.28 101.011 161.542 101.628 161.546H161.373C161.989 161.542 162.58 161.28 163.017 160.814C163.453 160.35 163.699 159.72 163.702 159.062V141.683C163.714 137.762 164.776 133.926 166.764 130.628C168.751 127.33 171.582 124.707 174.921 123.067ZM90.7356 194.712V200.677H96.3696V194.712H90.7356ZM90.22 207.677H87.4543C86.5842 207.677 85.7496 207.309 85.1343 206.651C84.5188 205.995 84.1731 205.106 84.1731 204.178V194.71C81.0919 194.675 78.1479 193.346 75.9792 191.011C73.8105 188.675 72.5917 185.523 72.5871 182.237V171.528H19.5934V219.418H90.2187L90.22 207.677ZM172.267 194.712H166.632V199.677C166.632 199.942 166.731 200.197 166.906 200.384C167.082 200.571 167.32 200.677 167.569 200.677H171.328C171.577 200.677 171.816 200.571 171.991 200.384C172.167 200.197 172.266 199.942 172.266 199.677L172.267 194.712ZM76.773 141.627C78.8824 141.54 81.3667 142.053 82.9525 143.606C83.4519 144.101 83.8518 144.699 84.1276 145.364C84.4036 146.03 84.5499 146.748 84.5575 147.475C84.6237 149.316 84.0987 151.753 82.7851 153.002C81.6451 154.086 79.6801 154.756 76.4145 154.58C73.8753 153.738 71.6463 152.071 70.0393 149.812C68.8351 148.108 68.0275 146.123 67.6836 144.021C67.3395 141.92 67.4688 139.76 68.0607 137.722C68.6527 135.684 69.6903 133.825 71.088 132.299C72.4857 130.772 74.2036 129.622 76.0999 128.943C77.9962 128.264 80.0167 128.075 81.9949 128.393C83.973 128.71 85.852 129.525 87.477 130.769C89.1021 132.013 90.4266 133.652 91.3414 135.549C92.2563 137.447 92.7351 139.549 92.7387 141.683V159.062C92.742 161.576 93.6798 163.986 95.3464 165.763C97.0131 167.541 99.2725 168.542 101.629 168.546H161.373C163.731 168.542 165.99 167.541 167.656 165.763C169.323 163.986 170.26 161.576 170.263 159.062V141.683C170.26 139.543 170.736 137.434 171.649 135.529C172.563 133.624 173.887 131.979 175.515 130.729C177.142 129.479 179.026 128.66 181.009 128.34C182.992 128.02 185.019 128.208 186.919 128.889C188.821 129.57 190.543 130.724 191.943 132.256C193.344 133.788 194.382 135.653 194.973 137.697C195.564 139.742 195.69 141.907 195.34 144.014C194.991 146.12 194.176 148.108 192.963 149.812C191.356 152.071 189.127 153.738 186.588 154.58C183.322 154.756 181.357 154.086 180.219 153.002C178.906 151.752 178.38 149.317 178.446 147.476C178.453 146.748 178.6 146.03 178.876 145.365C179.151 144.7 179.551 144.101 180.051 143.606C181.638 142.053 184.122 141.54 186.231 141.627C186.661 141.646 187.092 141.574 187.497 141.415C187.902 141.257 188.272 141.014 188.589 140.701C188.905 140.389 189.162 140.013 189.34 139.594C189.52 139.176 189.621 138.724 189.636 138.264C189.651 137.804 189.582 137.346 189.429 136.915C189.277 136.484 189.048 136.09 188.752 135.754C188.458 135.419 188.103 135.149 187.71 134.96C187.317 134.771 186.892 134.667 186.46 134.654C182.554 134.494 178.552 135.592 175.615 138.465C174.472 139.582 173.556 140.934 172.918 142.441C172.281 143.948 171.937 145.577 171.909 147.23C171.763 151.25 172.989 155.495 175.86 158.225C177.703 159.975 180.27 161.218 183.853 161.522V182.237C183.849 183.686 183.307 185.077 182.344 186.104C181.383 187.13 180.079 187.707 178.719 187.712H84.2824C82.9222 187.707 81.6189 187.13 80.6571 186.102C79.6954 185.077 79.1533 183.686 79.1496 182.237V161.522C82.7317 161.218 85.2996 159.976 87.1413 158.225C90.0129 155.495 91.2387 151.249 91.0933 147.229C91.0647 145.576 90.7212 143.947 90.0838 142.441C89.4465 140.934 88.5286 139.582 87.3859 138.465C84.4512 135.594 80.4484 134.493 76.5409 134.654C76.1098 134.667 75.6853 134.771 75.2919 134.96C74.8986 135.149 74.5441 135.419 74.2489 135.754C73.9539 136.09 73.7238 136.484 73.5723 136.915C73.4206 137.346 73.3504 137.804 73.3656 138.264C73.3807 138.724 73.4811 139.176 73.6608 139.594C73.8405 140.013 74.0961 140.389 74.4126 140.701C74.7292 141.014 75.1006 141.257 75.5055 141.415C75.9103 141.574 76.342 141.646 76.773 141.627Z"
          fill="white"
        />
      </svg>
    ),
  },
  // {
  //   title: 'Bonus Draw',
  //   answer: (
  //     <React.Fragment>
  //       <ul className="faq-list dark">
  //         <li>
  //           Buy Dream Home tickets before midnight on July 31 to also win a BMW 520i Sport worth £55,000 – or take the
  //           cash, tax-free.
  //         </li>
  //       </ul>
  //     </React.Fragment>
  //   ),
  //   icon: (
  //     <svg width="150" height="110" viewBox="0 0 150 110" fill="none" xmlns="http://www.w3.org/2000/svg">
  //       <path
  //         fillRule="evenodd"
  //         clipRule="evenodd"
  //         d="M147.669 50.0016H93.5359C92.2429 53.8376 89.6946 57.1257 86.3026 59.335C82.9626 61.575 77.7759 62.7483 72.6693 63.1416L82.6559 73.135C83.1199 73.5994 83.4879 74.1507 83.7389 74.7573C83.9898 75.364 84.1188 76.0141 84.1185 76.6707C84.1182 77.3272 83.9886 77.9772 83.7371 78.5836C83.4855 79.19 83.117 79.741 82.6526 80.205C82.1882 80.669 81.6369 81.037 81.0302 81.2879C80.4236 81.5388 79.7734 81.6678 79.1169 81.6675C78.4604 81.6672 77.8104 81.5376 77.204 81.2861C76.5975 81.0346 76.0466 80.6661 75.5826 80.2016L64.5493 69.1683V106.668H129.336C134.196 106.668 138.863 104.735 142.303 101.302C145.737 97.8601 147.667 93.1972 147.669 88.335V50.0016ZM25.1359 50.0016H4.33594V88.335C4.33594 93.195 6.26927 97.8616 9.7026 101.302C13.1441 104.736 17.8071 106.666 22.6693 106.668H54.5493V68.7416L43.0893 80.2016C42.1467 81.1129 40.8839 81.6175 39.5729 81.6067C38.2619 81.5959 37.0076 81.0707 36.0801 80.1441C35.1526 79.2174 34.6262 77.9636 34.6142 76.6526C34.6022 75.3417 35.1056 74.0784 36.0159 73.135L46.0026 63.1416C40.8959 62.7483 35.7093 61.575 32.3693 59.335C28.9773 57.1257 26.429 53.8376 25.1359 50.0016ZM34.3226 44.6816C34.394 43.8084 34.708 42.9725 35.2293 42.2683C37.3693 39.3416 41.9493 39.275 45.3893 41.5816C47.5359 43.015 49.1559 45.9483 50.5093 48.8083C51.2426 50.355 51.8759 51.9083 52.3959 53.3283C50.5792 53.3586 48.762 53.3119 46.9493 53.1883C43.6093 52.9416 40.1159 52.4883 37.9226 51.0216C35.8093 49.6083 34.4493 47.475 34.3226 45.4016L34.3359 45.0016L34.3226 44.6816ZM84.3493 45.4016C84.2226 47.475 82.8626 49.6083 80.7493 51.0216C78.5559 52.4883 75.0626 52.9416 71.7226 53.1883C69.8159 53.3216 67.9426 53.355 66.2759 53.3283C66.7959 51.9083 67.4293 50.355 68.1626 48.8083C69.5159 45.9483 71.1359 43.015 73.2826 41.5816C76.7226 39.275 81.3026 39.3416 83.4426 42.2683C83.9639 42.9725 84.2779 43.8084 84.3493 44.6816C84.3324 44.9213 84.3324 45.1619 84.3493 45.4016ZM64.5493 3.33496V36.075C65.5559 34.9683 66.6159 34.0083 67.7226 33.2683C75.8293 27.8483 86.4626 29.4683 91.5093 36.3483C92.3426 37.495 92.9893 38.7216 93.4559 40.0016H147.669V21.6683C147.669 16.8083 145.736 12.1416 142.303 8.70163C138.861 5.26693 134.198 3.337 129.336 3.33496H64.5493ZM54.5493 3.33496H22.6693C17.8093 3.33496 13.1426 5.26829 9.7026 8.70163C6.26791 12.1431 4.33798 16.8061 4.33594 21.6683V40.0016H25.2159C25.6826 38.7216 26.3293 37.495 27.1626 36.3483C32.2093 29.4683 42.8426 27.8483 50.9493 33.2683C52.2159 34.115 53.4226 35.2483 54.5493 36.5683V3.33496Z"
  //         fill="white"
  //       />
  //     </svg>
  //   ),
  // },
  {
    title: "Donation",
    answer: (
      <React.Fragment>
        <ul className="faq-list dark">
          <li>
            Win a home and donate to one of our charity partners at checkout.
            It’s time to dream big and do good.
          </li>
        </ul>
      </React.Fragment>
    ),
    icon: (
      <svg
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        tabindex="-1"
        title="Donation"
      >
        <path d="m12 21.35-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54z"></path>
      </svg>
    ),
  },
];

const dreamDrawFeatures = [
  {
    title: "5 bedrooms",
    icon: (
      <svg
        width="39"
        height="28"
        viewBox="0 0 39 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M35.7382 17.5156V5.79691C33.1494 5.79691 31.0507 3.69825 31.0507 1.10943H7.61327C7.61327 3.69825 5.5146 5.79691 2.92578 5.79691V17.5156V16.3438C2.92578 14.4021 4.49976 12.8281 6.4414 12.8281H32.2226C34.1642 12.8281 35.7382 14.4021 35.7382 16.3438V17.5156Z"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
        <path
          d="M7.61328 12.8281V10.4844C7.61328 9.18993 8.66265 8.14064 9.95702 8.14064H14.6445C15.9389 8.14064 16.9883 9.18993 16.9883 10.4844V12.8281"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
        <path
          d="M21.6758 12.8281V10.4844C21.6758 9.18993 22.7252 8.14064 24.0195 8.14064H28.707C30.0014 8.14064 31.0508 9.18993 31.0508 10.4844V12.8281"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
        <path
          d="M0.503906 26.8906V17.5157H38.16V26.8906H33.3944V24.5469H5.26952V26.8906H0.503906Z"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
      </svg>
    ),
  },
  {
    title: "6 bathrooms",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.039 20.5078H17.0078V15.2344C17.0078 14.2636 17.7948 13.4766 18.7656 13.4766H22.2812C23.252 13.4766 24.039 14.2636 24.039 15.2344V20.5078Z"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
        <path
          d="M15.25 7.91016C15.25 5.96854 13.676 4.39454 11.7344 4.39454C9.79269 4.39454 8.21875 5.96854 8.21875 7.91016H15.25Z"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
        <path
          d="M11.7343 4.39456C11.7343 2.45295 10.1604 0.878947 8.21873 0.878947H6.46093C4.51931 0.878947 2.94531 2.45295 2.94531 4.39456V15.2344"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
        <path
          d="M2.94531 18.75V22.2656C2.94531 25.1781 5.30628 27.5391 8.21873 27.5391H22.2812C25.1936 27.5391 27.5546 25.1781 27.5546 22.2656V18.75"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
        <path
          d="M23.8125 27.3947L25.7962 29.3784"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
        <path
          d="M6.68687 27.3947L4.70312 29.3784"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
        <path
          d="M24.0391 15.2344H27.6133C28.584 15.2344 29.3711 16.0214 29.3711 16.9922C29.3711 17.963 28.584 18.75 27.6133 18.75H24.0391"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
        <path
          d="M17.0078 18.75H2.88671C1.91594 18.75 1.12891 17.963 1.12891 16.9922C1.12891 16.0214 1.91594 15.2344 2.88671 15.2344H17.0078"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
      </svg>
    ),
  },
  {
    title: "5,384 sqft",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.96092 25.6055H2.44531V20.332H0.628906V18.5742C0.628906 17.6034 1.41594 16.8164 2.38671 16.8164H4.20311C5.17389 16.8164 5.96092 17.6034 5.96092 18.5742V22.9688"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
        <path
          d="M23.539 25.6055H27.0546V20.332H28.871V18.5742C28.871 17.6034 28.084 16.8164 27.1132 16.8164H25.2968C24.326 16.8164 23.539 17.6034 23.539 18.5742V22.9688M23.539 25.6055H5.96094V22.9688C5.96094 21.5125 7.14142 20.332 8.59765 20.332H20.9023C22.3585 20.332 23.539 21.5125 23.539 22.9688M23.539 25.6055V22.9688"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
        <path
          d="M27.0553 16.8164L27.3045 16.318C28.6581 13.6107 27.0146 10.3647 24.0313 9.85332L23.9695 9.84272C22.4464 9.58889 20.8823 9.86309 19.5364 10.6199C18.495 9.02211 16.704 8.02737 14.7507 8.02737C12.8059 8.02737 11.022 9.01344 9.97862 10.599C8.61445 9.80629 7.01379 9.52176 5.45999 9.79584C2.44911 10.3268 0.922801 13.77 2.29014 16.5046L2.446 16.8164"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
        <path
          d="M11.2344 13.3008L12.9922 16.8164"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
        <path
          d="M18.2656 13.3008L16.5078 16.8164"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
        <path
          d="M2.4414 0.878922L0.917969 6.15234H11.002L9.47861 0.878922H2.4414Z"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
        <path
          d="M5.96094 6.15261V9.72705"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
        <path
          d="M4.20312 25.6055V29.1211H7.71874V25.6055"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
        <path
          d="M21.7812 25.6055V29.1211H25.2969V25.6055"
          stroke="#2E2E2E"
          stroke-miterlimit="10"
        />
      </svg>
    ),
  },
  {
    title: "1 acre",
    icon: (
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_7302_28899)">
          <path
            d="M3.92578 38.8281H8.61327V27.1094L6.26952 24.7657L3.92578 27.1094V38.8281Z"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
          <path
            d="M13.3008 38.8281H17.9883V27.1094L15.6445 24.7657L13.3008 27.1094V38.8281Z"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
          <path
            d="M22.6758 38.8281H27.3633V27.1094L25.0195 24.7657L22.6758 27.1094V38.8281Z"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
          <path
            d="M8.61328 29.4531H13.3008"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
          <path
            d="M17.9883 29.4531H22.6758"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
          <path
            d="M32.0508 38.8281H36.7383V27.1094L34.3945 24.7657L32.0508 27.1094V38.8281Z"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
          <path
            d="M32.0507 1.17193C29.4619 1.17193 27.3633 3.2706 27.3633 5.85942V9.37573C25.7308 10.601 24.7601 12.6586 25.0804 14.9198C25.4955 17.8506 28.1998 19.9219 31.1599 19.9219H33.0176C35.9785 19.9219 38.6842 17.8504 39.0993 14.9188C39.4195 12.658 38.4479 10.6009 36.8158 9.37573C36.8158 9.37558 36.8164 9.37534 36.8164 9.37503V5.85942C36.8164 3.2706 34.6396 1.17193 32.0507 1.17193Z"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
          <path
            d="M32.0508 27.1094V15.2344"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
          <path
            d="M29.707 12.8906L32.0508 15.2344L34.3945 12.8906"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
          <path
            d="M27.3633 29.4531H32.0508"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
          <path
            d="M8.61328 34.1406H13.3008"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
          <path
            d="M17.9883 34.1406H22.6758"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
          <path
            d="M27.3633 34.1406H32.0508"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
          <path
            d="M0.332031 38.8281H3.92577"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
          <path
            d="M8.61328 38.8281H13.3008"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
          <path
            d="M17.9883 38.8281H22.6758"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
          <path
            d="M27.3633 38.8281H32.0508"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
          <path
            d="M36.7383 38.8281H40.332"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
          <path
            d="M8.61324 1.17193C6.02442 1.17193 3.84763 3.2706 3.84763 5.85942V9.37573C2.21514 10.601 1.24451 12.6586 1.56475 14.9198C1.9799 17.8506 4.68419 19.9219 7.64426 19.9219H9.50199C12.4628 19.9219 15.1685 17.8504 15.5837 14.9188C15.9038 12.658 14.9323 10.6009 13.3002 9.37573C13.3002 9.37558 13.3007 9.37534 13.3007 9.37503V5.85942C13.3007 3.2706 11.2021 1.17193 8.61324 1.17193Z"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
          <path
            d="M8.61328 27.1094V15.2344"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
          <path
            d="M6.26953 12.8906L8.61327 15.2344L10.957 12.8906"
            stroke="#2E2E2E"
            stroke-miterlimit="10"
          />
        </g>
        <defs>
          <clipPath id="clip0_7302_28899">
            <rect
              width="40"
              height="40"
              fill="white"
              transform="translate(0.332031)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    title: "2 bed annex",
    icon: (
      <svg
        width="28"
        height="30"
        viewBox="0 0 28 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M27.5729 8.88284L14.4863 0.957856C14.4137 0.913567 14.3303 0.890137 14.2453 0.890137C14.1602 0.890137 14.0768 0.913567 14.0042 0.957856L0.926087 8.88284C0.858978 8.92543 0.804193 8.98486 0.767186 9.05521C0.730178 9.12555 0.712237 9.20436 0.715149 9.28379V28.6412C0.715149 28.9001 0.898138 29.1211 1.157 29.1211H3.94765C4.07209 29.1182 4.19029 29.066 4.27631 28.976C4.36234 28.8861 4.40918 28.7657 4.40656 28.6412V15.3516H24.0941V28.6412C24.0914 28.7657 24.1383 28.8861 24.2243 28.976C24.3103 29.066 24.4285 29.1182 24.553 29.1211H27.3436C27.6025 29.1211 27.7855 28.9001 27.7855 28.6412V9.28391C27.7881 9.20432 27.7698 9.12544 27.7326 9.05508C27.6953 8.98472 27.6402 8.92534 27.5729 8.88284ZM4.40656 14.4141V12.5391H24.0941V14.4141H4.40656ZM26.848 28.1836H25.0316V12.0746C25.0295 11.9488 24.9782 11.8289 24.8888 11.7404C24.7993 11.652 24.6788 11.6022 24.553 11.6016H3.94765C3.82186 11.6022 3.7013 11.652 3.61183 11.7404C3.52236 11.8289 3.47111 11.9488 3.46906 12.0746V28.1836H1.65265V9.54817L14.2503 1.90678L26.848 9.54817V28.1836Z"
          fill="#2E2E2E"
        />
        <path
          d="M21.5315 20.6186L20.2926 17.2661C20.1807 16.9643 19.9798 16.7037 19.7164 16.5187C19.4531 16.3338 19.1397 16.2333 18.8179 16.2305H9.90313C9.58132 16.2333 9.26797 16.3338 9.00459 16.5188C8.74122 16.7037 8.54025 16.9643 8.42833 17.2661L7.20677 20.5675L6.72548 21.0214C6.49325 21.2214 6.30711 21.4694 6.17987 21.7482C6.05262 22.027 5.98729 22.3301 5.98837 22.6366V28.6412C5.98599 28.7658 6.03307 28.8862 6.11928 28.9761C6.2055 29.0661 6.32383 29.1182 6.44839 29.1211H9.57641C9.63782 29.1196 9.69833 29.1059 9.75445 29.0809C9.81058 29.056 9.86123 29.0202 9.90349 28.9756C9.94575 28.931 9.9788 28.8785 10.0007 28.8211C10.0227 28.7638 10.0331 28.7026 10.0313 28.6412V26.9531H18.4688V28.6412C18.4671 28.7026 18.4775 28.7638 18.4994 28.8211C18.5214 28.8785 18.5544 28.931 18.5967 28.9756C18.6389 29.0202 18.6896 29.056 18.7457 29.0809C18.8018 29.1059 18.8623 29.1196 18.9238 29.1211H22.0518C22.1763 29.1182 22.2947 29.0661 22.3809 28.9761C22.4671 28.8862 22.5142 28.7658 22.5118 28.6412V22.5101C22.5121 22.2238 22.4547 21.9404 22.3429 21.6768C22.2312 21.4132 22.0674 21.1748 21.8614 20.976L21.5315 20.6186ZM9.30741 17.6016C9.35191 17.478 9.43247 17.3706 9.53868 17.2933C9.64488 17.216 9.77184 17.1723 9.90313 17.168H18.8179C18.9492 17.1723 19.0761 17.216 19.1823 17.2933C19.2885 17.3706 19.3691 17.478 19.4136 17.6016L20.4398 20.3906H8.28114L9.30741 17.6016ZM9.09384 28.1836H6.92587V26.9531H9.09384V28.1836ZM19.4063 28.1836V26.9531H21.5743V28.1836H19.4063ZM21.5743 26.0156H6.92587V22.6366C6.92492 22.4646 6.96155 22.2944 7.03319 22.1381C7.10484 21.9817 7.20977 21.8429 7.34065 21.7313C7.34604 21.7267 7.34915 21.7319 7.35436 21.727L7.79188 21.3281H20.8929L21.1906 21.6363C21.1971 21.6434 21.1996 21.6453 21.2066 21.6519C21.3232 21.7623 21.416 21.8954 21.4792 22.043C21.5424 22.1906 21.5748 22.3496 21.5743 22.5101V26.0156Z"
          fill="#2E2E2E"
        />
        <path
          d="M9.24105 22.4414H8.9707C8.60551 22.4414 8.25528 22.5865 7.99705 22.8447C7.73882 23.1029 7.59375 23.4532 7.59375 23.8184C7.59375 24.1836 7.73882 24.5338 7.99705 24.792C8.25528 25.0502 8.60551 25.1953 8.9707 25.1953H9.24105C9.60625 25.1953 9.95648 25.0502 10.2147 24.792C10.4729 24.5338 10.618 24.1836 10.618 23.8184C10.618 23.4532 10.4729 23.1029 10.2147 22.8447C9.95648 22.5865 9.60625 22.4414 9.24105 22.4414ZM9.24105 24.2578H8.9707C8.85415 24.2578 8.74238 24.2115 8.65996 24.1291C8.57755 24.0467 8.53125 23.9349 8.53125 23.8184C8.53125 23.7018 8.57755 23.59 8.65996 23.5076C8.74238 23.4252 8.85415 23.3789 8.9707 23.3789H9.24105C9.3576 23.3789 9.46938 23.4252 9.55179 23.5076C9.63421 23.59 9.68051 23.7018 9.68051 23.8184C9.68051 23.9349 9.63421 24.0467 9.55179 24.1291C9.46938 24.2115 9.3576 24.2578 9.24105 24.2578ZM19.5325 22.4414H19.2621C18.8969 22.4414 18.5467 22.5865 18.2885 22.8447C18.0302 23.1029 17.8852 23.4532 17.8852 23.8184C17.8852 24.1836 18.0302 24.5338 18.2885 24.792C18.5467 25.0502 18.8969 25.1953 19.2621 25.1953H19.5325C19.8977 25.1953 20.2479 25.0502 20.5061 24.792C20.7643 24.5338 20.9094 24.1836 20.9094 23.8184C20.9094 23.4532 20.7643 23.1029 20.5061 22.8447C20.2479 22.5865 19.8977 22.4414 19.5325 22.4414ZM19.5325 24.2578H19.2621C19.1456 24.2578 19.0338 24.2115 18.9514 24.1291C18.869 24.0467 18.8227 23.9349 18.8227 23.8184C18.8227 23.7018 18.869 23.59 18.9514 23.5076C19.0338 23.4252 19.1456 23.3789 19.2621 23.3789H19.5325C19.649 23.3789 19.7608 23.4252 19.8432 23.5076C19.9256 23.59 19.9719 23.7018 19.9719 23.8184C19.9719 23.9349 19.9256 24.0467 19.8432 24.1291C19.7608 24.2115 19.649 24.2578 19.5325 24.2578ZM17.0641 22.9688C17.0641 22.8444 17.0147 22.7252 16.9268 22.6373C16.8389 22.5494 16.7197 22.5 16.5953 22.5H11.8492C11.7249 22.5 11.6057 22.5494 11.5178 22.6373C11.4299 22.7252 11.3805 22.8444 11.3805 22.9688V24.7266C11.3805 24.8509 11.4299 24.9701 11.5178 25.058C11.6057 25.1459 11.7249 25.1953 11.8492 25.1953H16.5953C16.7197 25.1953 16.8389 25.1459 16.9268 25.058C17.0147 24.9701 17.0641 24.8509 17.0641 24.7266V22.9688ZM16.1852 24.2578H12.318V23.4375H16.1852V24.2578Z"
          fill="#2E2E2E"
        />
      </svg>
    ),
  },
  {
    title: "Tranquil",
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_8365_1885)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.0674 39.4844C6.74868 39.4844 0 32.7357 0 24.417C0 16.1217 6.74868 9.37305 15.0674 9.37305C23.3626 9.37305 30.1113 16.1217 30.1113 24.417C30.1113 26.7837 29.6192 29.0098 28.5647 31.1188C28.4007 31.3766 28.0961 31.5172 27.7914 31.3766C27.5571 31.2125 27.3931 30.9313 27.5571 30.6267C28.4944 28.7052 29.01 26.5962 29.01 24.417C29.01 16.731 22.7065 10.4275 15.0205 10.4275C7.31107 10.4275 1.00762 16.731 1.00762 24.417C1.00762 32.1264 7.31107 38.4299 15.0205 38.4299C15.5126 38.4299 16.075 38.3596 16.5671 38.3127C16.8717 38.2658 17.1295 38.5236 17.1763 38.8282C17.2232 39.1329 16.9654 39.3672 16.6842 39.4375C16.1687 39.4844 15.6063 39.4844 15.0674 39.4844ZM18.4417 39.1329C18.1839 39.1329 17.9731 38.9688 17.8793 38.7345C17.8325 38.4299 17.9731 38.1252 18.2777 38.0784C21.2537 37.3754 23.9719 35.6414 25.8934 33.2981C26.0808 33.0403 26.4323 33.0403 26.6432 33.1809C26.901 33.3918 26.901 33.7433 26.737 33.9307C24.6749 36.5084 21.7692 38.3596 18.5354 39.1329C18.5354 39.086 18.4886 39.1329 18.4417 39.1329Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.45236 12.607H7.35863C7.054 12.5367 6.86654 12.3024 6.9134 11.9978L8.27251 2.22623C8.41311 1.21861 9.1161 0.515625 10.03 0.515625H20.0358C20.9497 0.515625 21.6527 1.21861 21.8167 2.22623L23.1758 11.9978C23.2227 12.3024 23.0118 12.5367 22.7072 12.607C22.4026 12.6539 22.1682 12.443 22.1214 12.1384L20.7623 2.36683C20.692 2.01533 20.4576 1.61697 20.1061 1.61697H10.0768C9.67849 1.61697 9.46759 1.96847 9.42072 2.36683L8.06161 12.1384C7.96788 12.3961 7.75699 12.607 7.45236 12.607Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.201 9.32629C20.1541 9.32629 20.1073 9.32629 20.037 9.27943C16.8267 8.22494 13.3117 8.22494 10.078 9.27943C9.89052 9.32629 9.72649 9.27943 9.5859 9.16226C9.42187 9.06853 9.375 8.88107 9.375 8.67017L10.1717 2.88224C10.242 2.62448 10.4295 2.43701 10.7341 2.43701H19.4512C19.6855 2.43701 19.9432 2.62448 19.9901 2.88224L20.8103 8.67017C20.8571 8.88107 20.7634 9.02166 20.5994 9.16226C20.4588 9.27943 20.3416 9.32629 20.201 9.32629ZM11.1793 3.53836L10.5935 8.01405C13.4992 7.21733 16.6861 7.21733 19.5918 8.01405L18.9825 3.53836H11.1793ZM31.1208 34.1418H19.2403C18.9356 34.1418 18.6779 33.884 18.6779 33.5794V30.8611C18.6779 30.5565 18.9356 30.3222 19.2403 30.3222H31.1208C31.4254 30.3222 31.6831 30.5565 31.6831 30.8611V33.5794C31.6831 33.884 31.4254 34.1418 31.1208 34.1418ZM19.8027 33.0404H30.5584V31.4235H19.8027V33.0404Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.1323 39.4845C31.7263 39.4845 30.625 38.3128 30.625 36.9537V27.4868C30.625 26.0808 31.7732 24.9795 33.1323 24.9795C34.5383 24.9795 35.6396 26.1277 35.6396 27.4868V36.9537C35.6396 38.3597 34.4914 39.4845 33.1323 39.4845ZM33.1323 26.034C32.3356 26.034 31.6795 26.6901 31.6795 27.4868V36.9537C31.6795 37.7739 32.3356 38.43 33.1323 38.43C33.929 38.43 34.5852 37.7739 34.5852 36.9537V27.4868C34.5383 26.6901 33.8822 26.034 33.1323 26.034Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.1015 37.2114C34.7968 37.2114 34.5391 36.9536 34.5391 36.649C34.5391 36.3678 34.7968 36.11 35.1015 36.11C36.1091 36.11 36.9058 35.1962 36.9058 34.0948V30.1112C36.9058 29.0099 36.1091 28.096 35.1015 28.096C34.7968 28.096 34.5391 27.8382 34.5391 27.557C34.5391 27.2524 34.7968 26.9946 35.1015 26.9946C36.7183 26.9946 38.0071 28.4006 38.0071 30.0643V34.0479C38.0071 35.8523 36.7183 37.2114 35.1015 37.2114Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M37.9134 34.4933H37.4682C37.1636 34.4933 36.9058 34.2355 36.9058 33.9309C36.9058 33.6497 37.1636 33.3919 37.4682 33.3919H37.9134C38.4758 33.3919 38.8742 32.8764 38.8742 32.2906V31.9859C38.8742 31.3767 38.429 30.8612 37.9134 30.8612H37.4682C37.1636 30.8612 36.9058 30.6268 36.9058 30.3222C36.9058 30.0176 37.1636 29.7598 37.4682 29.7598H37.9134C39.0851 29.7598 39.9755 30.7674 39.9755 31.9156V32.2203C39.9755 33.4856 39.0851 34.4933 37.9134 34.4933ZM17.2222 39.4845C15.8162 39.4845 14.7148 38.3128 14.7148 36.9537V27.4868C14.7148 26.0808 15.8631 24.9795 17.2222 24.9795C18.5813 24.9795 19.7529 26.1277 19.7529 27.4868V36.9537C19.7998 38.3597 18.6281 39.4845 17.2222 39.4845ZM17.2222 26.034C16.4254 26.034 15.7693 26.6901 15.7693 27.4868V36.9537C15.7693 37.7739 16.4254 38.43 17.2222 38.43C18.0423 38.43 18.675 37.7739 18.675 36.9537V27.4868C18.675 26.6901 18.0423 26.034 17.2222 26.034Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.2533 37.2114C13.6599 37.2114 12.3477 35.8054 12.3477 34.1417V30.1581C12.3477 28.4475 13.6599 27.0884 15.2533 27.0884C15.558 27.0884 15.8157 27.3461 15.8157 27.6508C15.8157 27.9554 15.558 28.2132 15.2533 28.2132C14.2457 28.2132 13.449 29.1036 13.449 30.205V34.1886C13.449 35.2899 14.2457 36.2038 15.2533 36.2038C15.558 36.2038 15.8157 36.4615 15.8157 36.7662C15.8157 37.0708 15.558 37.2114 15.2533 37.2114Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.8862 34.4932H12.441C11.2928 34.4932 10.3789 33.4856 10.3789 32.3374V32.0328C10.3789 30.8143 11.2928 29.8535 12.441 29.8535H12.8862C13.1909 29.8535 13.4486 30.1113 13.4486 30.4159C13.4486 30.7205 13.1909 30.9783 12.8862 30.9783H12.441C11.8786 30.9783 11.4803 31.4704 11.4803 32.0796V32.3843C11.4803 32.9935 11.9489 33.4856 12.441 33.4856H12.8862C13.1909 33.4856 13.4486 33.7434 13.4486 34.048C13.4486 34.3526 13.1909 34.4932 12.8862 34.4932Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_8365_1885">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
];

const heroGalleryImages = [
  `The_West_Sussex_Dream_Home`,
  `The_West_Sussex_Dream_Home_2`,
  `The_Orangery_Kitchen`,
  `The_Orangery_Kitchen_2`,
  `The_Orangery_Kitchen_3`,
  `The_Orangery_Kitchen_4`,
  `The_Orangery_Kitchen_5`,
  `The_Dining_Room`,
  `The_Dining_Room_2`,
  `The_Dining_Room_3`,
  `The_Drawing_Room`,
  `The_Drawing_Room_2`,
  "The_Drawing_Room_3",
  "The_Sitting_Room",
  "Six_Stunning_Bedrooms",
  "Six_Stunning_Bedrooms_2",
  "Six_Stunning_Bedrooms_3",
  "Five_Lovely_Bathrooms",
  "The_Grounds",
  "The_Grounds_2",
];

const heroInfoData = [
  {
    title: "Key info",
    content: [
      "No purchase, payment or other financial contribution is necessary to enter or win any of our competitions. A free postal entry is available for all competitions.",
      'Entrants must be 18 or older. <a href="/legal/0" target="_blank">Full T&Cs can be found here</a>',
    ],
  },
  {
    title: "Key dates",
    content: [
      // {
      //   text: "<b>Midnight July 31:</b><br/>The Porsche Bonus Draw closes.",
      //   icon: (
      //     <svg
      //       width="91"
      //       height="78"
      //       viewBox="0 0 91 78"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M4.34094 56.2904V54.345H87.8319C88.04 56.012 87.9318 57.71 87.5145 59.326C87.0972 60.942 86.3804 62.4389 85.4119 63.717C84.4433 64.9951 83.2451 66.0252 81.8972 66.7385C80.5493 67.4519 79.0825 67.8321 77.5945 67.8541H14.5624C11.8519 67.8526 9.25274 66.6339 7.33613 64.4656C5.41952 62.2973 4.34221 59.3569 4.34094 56.2904ZM77.5623 10.5086C77.5623 10.5086 79.7159 18.945 79.8766 19.345H12.2963C12.497 18.959 13.246 15.9316 13.8449 13.511C14.2051 12.055 14.511 10.8187 14.6106 10.5086C15.3776 7.50688 16.9841 4.86731 19.1891 2.98571C21.3942 1.1041 24.079 0.081861 26.8409 0.0722656H65.332C68.0933 0.0845067 70.777 1.10775 72.9816 2.98896C75.1862 4.87017 76.7932 7.50825 77.5623 10.5086ZM5.69966 15.4148C7.33397 15.068 9.58169 14.5911 10.1749 14.8177C9.93218 15.7432 5.14451 25.545 5.14451 25.545L3.8588 25.2359C2.89556 24.9827 2.0392 24.3608 1.43456 23.4755C0.82993 22.5902 0.514138 21.4958 0.5406 20.3775C0.567062 19.2591 0.934155 18.1854 1.57979 17.338C2.22542 16.4905 3.10996 15.9214 4.08379 15.7268C4.36898 15.6972 4.97382 15.5688 5.69966 15.4148ZM82.0945 14.6723L86.9159 15.5814C87.9196 15.7629 88.8327 16.3448 89.4901 17.2219C90.1475 18.099 90.5056 19.2133 90.4998 20.3632C90.493 21.5331 90.1168 22.6618 89.4389 23.5453C88.761 24.4289 87.8263 25.0092 86.8034 25.1814C86.4307 24.5065 85.9608 23.7291 85.4703 22.9178C84.5734 21.4341 83.6079 19.8368 83.0427 18.545C82.6156 17.2717 82.2507 15.9727 81.9498 14.6541C81.9739 14.6541 81.998 14.6586 82.0221 14.6632C82.0462 14.6677 82.0703 14.6723 82.0945 14.6723Z"
      //         fill="#043B3B"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M81.6444 22.9632C81.5757 22.9783 81.5055 22.9844 81.4355 22.9814H10.7374C10.6673 22.9844 10.5972 22.9783 10.5284 22.9632L6.96058 29.0359C5.24771 31.9364 4.33586 35.3476 4.34094 38.8359V50.7086H87.8319V38.8359C88.118 32.9214 84.3878 27.5995 81.6444 22.9632Z"
      //         fill="#043B3B"
      //       />
      //       <path
      //         d="M14.5574 71.491C12.6127 71.4933 10.6909 71.0163 8.9257 70.0932C7.1605 69.17 5.59426 67.8229 4.33594 66.1455V72.1637C4.34104 73.6968 4.88385 75.165 5.84512 76.2457C6.8064 77.3264 8.10753 77.9312 9.46272 77.9273H14.2199C15.575 77.9312 16.8762 77.3264 17.8375 76.2457C18.7987 75.165 19.3415 73.6968 19.3466 72.1637V71.491C18.2811 71.4946 15.5827 71.4891 14.5574 71.491ZM84.6127 69.2546C81.2055 71.8601 76.818 71.5237 72.8162 71.491V72.1637C72.8162 73.6923 73.353 75.1583 74.3084 76.2392C75.2639 77.3201 76.5597 77.9273 77.9109 77.9273H82.7002C84.0554 77.9312 85.3565 77.3264 86.3178 76.2457C87.279 75.165 87.8218 73.6968 87.827 72.1637V66.1455C86.9066 67.3665 85.8218 68.4158 84.6127 69.2546Z"
      //         fill="#043B3B"
      //       />
      //       <path
      //         d="M41.4777 46.3148C42.2782 46.3148 42.911 45.5588 42.911 44.6227L42.8985 44.6126L42.9068 43.4061C42.9236 40.4524 42.186 38.2096 40.7233 36.7328C39.2857 35.266 37.2363 34.52 34.6294 34.5H34.6043L34.5247 34.51H34.4953C31.6957 34.51 29.5666 35.276 28.1668 36.7829C26.7502 38.3098 26.0251 40.5876 26.0084 43.5613L26 44.4875C26 45.4337 26.6245 46.1996 27.4166 46.1996C28.2087 46.1996 28.8416 45.4437 28.8499 44.5075V43.7966C28.8583 42.4299 29.0008 41.3636 29.29 40.5426C29.5498 39.7416 29.9229 39.0857 30.4174 38.6001C30.8952 38.1446 31.4736 37.8141 32.1483 37.6389C32.8776 37.4737 33.6362 37.3786 34.4115 37.3786H34.5205C35.388 37.3786 36.1927 37.4887 36.922 37.704C37.58 37.9193 38.1416 38.2547 38.6361 38.7603C39.0971 39.2209 39.4366 39.8066 39.709 40.6126C39.9521 41.4086 40.0779 42.4049 40.0695 43.5663L40.0611 44.6026C40.0611 45.5488 40.6772 46.3148 41.4777 46.3148Z"
      //         fill="#F8F4F0"
      //       />
      //       <path
      //         d="M64.5622 46.5C65.3543 46.5 65.9955 45.7441 65.9955 44.8079L65.9913 44.7979L65.9997 43.5914C66.0165 40.6377 65.2789 38.3849 63.8162 36.918C62.3828 35.4512 60.3334 34.6952 57.7265 34.6752H57.6888L57.6343 34.6952H57.5463C54.776 34.6952 52.6553 35.4612 51.2555 36.9681C49.8473 38.485 49.1222 40.7628 49.1055 43.7466L49.0971 44.6727C49.0971 45.6089 49.7299 46.3748 50.5137 46.3849C51.2974 46.3849 51.9386 45.6289 51.947 44.6927V43.9819C51.9554 42.6151 52.0979 41.5488 52.3787 40.7178C52.6511 39.8967 53.0283 39.2509 53.5061 38.7854C53.9755 38.3298 54.5622 38.0094 55.2412 37.8242C55.9872 37.6489 56.7458 37.5538 57.496 37.5538H57.605C58.4809 37.5638 59.294 37.674 60.0065 37.8892C60.6645 38.0845 61.2261 38.4299 61.729 38.9355C62.19 39.4161 62.5421 40.0219 62.7935 40.7979C63.045 41.5989 63.1707 42.5901 63.1624 43.7416L63.154 44.7879C63.154 45.724 63.7868 46.49 64.5622 46.5Z"
      //         fill="#F8F4F0"
      //       />
      //     </svg>
      //   ),
      // },
      {
        text: "<b>Midnight August 31:</b><br/>The West Sussex Dream Home Draw closes <b>& the 2-4-1 offer ends</b>.",
        icon: (
          <svg
            width="91"
            height="80"
            viewBox="0 0 91 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_7692_4117)">
              <path
                d="M45.9108 0L6.93374 18.2606L6.65625 60.6595C11.7551 64.2386 25.6889 73.0166 45.44 73.1606C51.5943 73.1966 67.8769 72.4716 84.3824 61.1995L84.65 18.8005L45.9108 0ZM42.1994 43.6382C42.1994 44.5999 41.4512 45.3764 40.5047 45.3764C39.5583 45.3764 38.8299 44.5896 38.8299 43.6177L38.8398 42.5532C38.8497 41.3602 38.7011 40.3368 38.4137 39.5192C38.0916 38.6913 37.6902 38.0896 37.1452 37.6165C36.5604 37.0971 35.8965 36.7526 35.1185 36.5315C34.2563 36.3103 33.3049 36.1972 32.2792 36.1972H32.1504C31.2337 36.1972 30.3368 36.2949 29.4746 36.4646C28.6768 36.6446 27.993 36.984 27.4281 37.452C26.8434 37.9508 26.4024 38.6244 26.0952 39.4472C25.7533 40.2905 25.5848 41.3859 25.5749 42.7897V43.52C25.565 44.4816 24.8168 45.2581 23.8803 45.2581C22.9438 45.2581 22.2054 44.4713 22.2054 43.4994L22.2154 42.548C22.2352 39.4935 23.0924 37.1537 24.7672 35.5853C26.4223 34.0374 28.9395 33.2506 32.2495 33.2506H32.2842L32.3783 33.2403H32.4081C35.4901 33.2609 37.9132 34.0271 39.6128 35.5338C41.3421 37.0508 42.2142 39.3546 42.1944 42.3886L42.1845 43.6279L42.1994 43.6382ZM69.4922 43.8285C69.4922 44.7901 68.7341 45.5666 67.7976 45.5666C66.8809 45.5563 66.1327 44.7696 66.1327 43.8079L66.1426 42.7332C66.1525 41.5504 66.0038 40.5322 65.7065 39.7095C65.4092 38.9124 64.993 38.2902 64.4479 37.7965C63.8533 37.2771 63.1893 36.9223 62.4114 36.7217C61.569 36.5006 60.6077 36.3875 59.5721 36.3772H59.4432C58.5563 36.3772 57.6594 36.4749 56.7774 36.6549C55.9746 36.8451 55.2809 37.1743 54.7259 37.6422C54.1611 38.1205 53.7151 38.7838 53.393 39.6272C53.061 40.4808 52.8926 41.5761 52.8826 42.98V43.7102C52.8727 44.6718 52.1146 45.4483 51.188 45.4483C50.2614 45.4381 49.5132 44.6513 49.5132 43.6897L49.5231 42.7383C49.5429 39.6735 50.4001 37.3337 52.065 35.7755C53.7201 34.2277 56.2274 33.4409 59.5027 33.4409H59.6068L59.6712 33.4203H59.7158C62.7979 33.4409 65.2209 34.2174 66.9156 35.7241C68.6449 37.2308 69.517 39.5449 69.4972 42.5789L69.4873 43.8182L69.4922 43.8285Z"
                fill="#043B3B"
              />
              <path
                d="M22.2671 0.108584L22.2126 8.87634L12.8721 13.2114H12.8672L12.9465 0.046875L22.2671 0.108584Z"
                fill="#043B3B"
              />
              <path
                d="M90.5 64.7328C90.5 65.391 90.173 66.0029 89.6477 66.3578C81.7988 71.6133 73.1273 75.5678 64.0347 77.8047C58.029 79.2806 51.7311 80.0108 45.4034 80.0005C39.0757 79.9234 32.7827 79.1006 26.8018 77.5476C17.7389 75.1872 9.11697 71.1145 1.33742 65.751C0.807218 65.391 0.5 64.7739 0.5 64.1105C0.50991 62.5421 2.21447 61.6268 3.46317 62.5267L4.66726 63.4009C16.8222 72.1841 31.0186 76.514 45.4182 76.6322C59.8178 76.7145 74.0688 72.58 86.3377 63.9614L87.5517 63.1026C88.8103 62.2182 90.505 63.1592 90.495 64.7276L90.5 64.7328Z"
                fill="#043B3B"
              />
            </g>
            <defs>
              <clipPath id="clip0_7692_4117">
                <rect
                  width="90"
                  height="80"
                  fill="white"
                  transform="translate(0.5)"
                />
              </clipPath>
            </defs>
          </svg>
        ),
      },
    ],
  },
  {
    title: "The Draw",
    content: [
      "All tickets purchased before midnight August 31, as well as eligible postal entries, will be entered into the West Sussex Dream Home Draw<b> & the Historic Dream Home Draw</b>.",
      "The winner of each competition will be drawn the Friday following the close date. All draws are independently conducted by Civica.",
      "Dream big & do good. Good luck!",
    ],
  },
];

export {
  singlePrizeData,
  doublePrizeData,
  dreamDrawAccordion,
  dreamDrawFeatures,
  heroGalleryImages,
  heroInfoData,
};
